import { render, staticRenderFns } from "./SidebarAddContact.vue?vue&type=template&id=30b983a6&"
import script from "./SidebarAddContact.vue?vue&type=script&lang=js&"
export * from "./SidebarAddContact.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports